import { render, staticRenderFns } from "./animate-popup.vue?vue&type=template&id=6fbff4bf&scoped=true&"
import script from "./animate-popup.vue?vue&type=script&lang=ts&"
export * from "./animate-popup.vue?vue&type=script&lang=ts&"
import style0 from "./animate-popup.vue?vue&type=style&index=0&id=6fbff4bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbff4bf",
  null
  
)

export default component.exports